import * as React from "react";
import PropTypes from "prop-types";

const STYLE = {
  position: "fixed",
  bottom: 0,
  left: 0,
  padding: 4,
  fontSize: 12,
  background: "#000",
  color: "#fff",
  borderRadius: 2,
  margin: 4,
  fontWeight: "bold",
  zIndex: 999,
  cursor: "pointer"
};

function PRIndicator({ prNumber }) {
  return (
    <div
      id="pr-indicator"
      style={STYLE}
      title="Click to clear PR"
      onClick={() => {
        const searchParams = new URLSearchParams(window.location.search);
        searchParams.set("pr", "none");
        window.location.search = searchParams.toString();
      }}
    >
      PR {prNumber}
    </div>
  );
}

PRIndicator.propTypes = {
  prNumber: PropTypes.string.isRequired
};

export default PRIndicator;
